<style>
  .exc-viewer-button-right {
    background-color: rgba(0, 0, 0, 0.5);;
    line-height: 150px;
    border-radius: 0 5px 5px 0;
    width: 24px;
    text-align: center;
    margin-right: 8px;
  }

  .exc-viewer-button-left {
    background-color: rgba(0, 0, 0, 0.5);;
    line-height: 150px;
    border-radius: 5px 0 0 5px;
    width: 24px;
    text-align: center;
    margin-left: 8px;
  }

  .exc-viewer-button-right:hover, .exc-viewer-button-left:hover {
    cursor: pointer;
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>
<div class="modal-body modal-max">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{getRessource('DocumentHeader')}}</h5>
    <div class="content">
      <div class="layout-auto-1-auto">
        <div style="text-align: center; line-height: 2rem">{{currentItem?.FileName}}</div>
        <div class="content" style="background: var(--c-dark-m1)">
          <div class="grid-auto-1-auto grid-full-height" style="align-items: center">
            <div>
              <div class="exc-viewer-button-left" [class.disabled]="currentIndex <= 0" (click)="showPrev()">
                <i class="fas fa-fw fa-caret-left"></i>
              </div>
            </div>
            <div class="content">
              <div *ngIf="isLoading" class="loading-animation" style="z-index: 10;">
                <i class="fas fa-spinner-third fa-spin"></i>
              </div>
              <div *ngIf="!isLoading && galleryDataCount === 0">
                 <div class="splash empty"><p>{{getRessource('NoGalleryData')}}</p></div>
              </div>
              <div *ngIf="notSupportedMIME" class="grid-full-height gh-ai-center"
                   style="font-family:Roboto,Arial, Helvetica, sans-serif!important; align-items: center">
                <h3 class="not-supported-mime"
                    style="color: white; text-align: center;">{{getRessource('NotSupportedMIME', {fileName: currentItem?.FileName})}}</h3>
              </div>
              <div *ngIf="!notSupportedMIME" class="host-container" style="height: 100%"
                   [class.center-video]="currentItem && isCurrentItemVideo()">
                  <img #imgHost class="host-image-view"
                       *ngIf="currentItem && isCurrentItemImage()"
                       data-scale="1" [src]="currentResource || ''"
                       [alt]="currentItem?.FileName">

                <video *ngIf="currentItem && isCurrentItemVideo()" #vidHost class="host-video-view"
                       style="height: 100%; width: 100%; max-height: 90%;max-width: 90%;" controls>
                  <source [src]="currentResource || ''" [type]="currentItem?.MIME"/>
                  {{getRessource('NotSupportedVideo')}}
                </video>
                <div *ngIf="currentItem && isCurrentItemPDF()" style="height: 100%;">
                  <div class="pdf-viewer-box" style="height: 1px;">
                    <pdf-viewer class="host-pdf-view" style="display: block;"
                                [src]="currentResource || null"
                                [render-text]="false" [original-size]="true" [fit-to-page]="false" [show-borders]="true"
                                [show-all]="true"></pdf-viewer>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="exc-viewer-button-right" [class.disabled]="currentIndex >= galleryDataCount -1"
                   (click)="showNext()">
                <i class="fas fa-fw fa-caret-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-auto-1-auto" style="justify-items: center; align-items: center;
    height: 3.25rem;">
      <div class="spawn">
        <button [disabled]="isDisabled" class="search-filter-action"
                [dnd]="true"
                [multiple]="true" (filesSelect)="fileUpload($event)" appExgDirectUploadV2>
          <i class="far fa-file-plus"></i></button>
        <button class="search-filter-action" (click)="downloadCurrentItem()"
                [tooltip]="'Anlage downloaden'"
                [disabled]="isDisabled"><i class="far fa-fw fa-download"></i></button>
        <button [disabled]="isDisabled || galleryDataCount === 0" class="search-filter-action"
                (click)="fileDelete(currentItem)"><i class="far fa-trash"></i></button>
      </div>
      <div>{{ currentIndex + 1}} / {{ galleryDataCount }}</div>
      <div class="spawn-modal-actions">
        <button class="md-btn" (click)="modalService.action(galleryDataCount)">{{getGlobal('Close')}}</button>
      </div>
    </div>
  </div>
</div>
